// Added by Claude (AI) — 2026-10-03 — totals row at the end of report tables (Rubi Farms reports, phase 1)
import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell } from '@mui/material';
import useLocales from '../../hooks/useLocales';
import { numberByLocale } from '../../utils/misc';

TableTotalsRow.propTypes = {
    headers: PropTypes.array.isRequired,
    totals: PropTypes.object.isRequired,
    hasCheckbox: PropTypes.bool,
};

export default function TableTotalsRow({ headers, totals, hasCheckbox = false }) {
    const { translate, currentLang } = useLocales();

    const visibleHeaders = headers.filter((column) => column.show);
    const labelIndex = visibleHeaders.findIndex((column) => totals[column.id] === undefined);

    // Nothing to add up in the visible columns (e.g. the weight column is hidden)
    if (!visibleHeaders.some((column) => totals[column.id] !== undefined)) return null;

    return (
        <TableRow
            sx={{
                '& td': {
                    fontWeight: 'fontWeightBold',
                    borderTop: (theme) => `2px solid ${theme.palette.divider}`,
                },
            }}
        >
            {hasCheckbox && <TableCell padding="checkbox" />}
            {visibleHeaders.map((column, index) => {
                const value = totals[column.id];
                let cellValue = '';

                if (value !== undefined && value !== null && !Number.isNaN(+value)) {
                    cellValue = numberByLocale(value, currentLang.locale);
                } else if (index === labelIndex) {
                    cellValue = translate('total');
                }

                return (
                    <TableCell key={column.id || column.label} align={column.align}>
                        {cellValue}
                    </TableCell>
                );
            })}
        </TableRow>
    );
}
